const filterForm = {
  'name-placeholder': 'ชื่อ-สกุล',
  'organization-placeholder': 'Organization',
  'code-placeholder': 'รหัสพนักงาน',
  'date-placeholder': 'วันที่',
  'status-placeholder': 'สถานะของพนักงาน',
  'leaveType-placeholder': 'ประเภทการลา',
  organization: {
    placeholder: 'ชื่อองค์กร..',
    label: 'ชื่อองค์กร'
  },
  'employee-code': {
    placeholder: 'รหัสพนักงาน..',
    label: 'รหัสพนักงาน'
  },
  'name-surname': {
    placeholder: 'ชื่อ - นามสกุล..',
    label: 'ชื่อ - นามสกุล'
  },
  position: {
    placeholder: 'ตำแหน่ง..',
    label: 'ตำแหน่ง'
  },
  level: {
    placeholder: 'ระดับงาน..',
    label: 'ระดับงาน'
  },
  status: {
    placeholder: 'สถานะของพนักงาน..',
    label: 'สถานะของพนักงาน'
  },
  d: {
    placeholder: 'วันที่',
    label: 'วันที่'
  },
  date: {
    placeholder: {
      'start-date': 'วันที่เริ่ม..',
      'end-date': 'วันที่สิ้นสุด..'
    },
    label: 'วันที่'
  },
  year: {
    placeholder: 'ปี',
    label: 'ปี'
  },
  'leave-status': {
    placeholder: 'สถานะการลา..',
    label: 'สถานะการลา'
  },
  'leave-type': {
    placeholder: 'ประเภทการลา..',
    label: 'ประเภทการลา'
  }
}

export default {
  title: 'การบริหารจัดการวันลาออนไลน์ - รายงานการลา',
  exportForm: {
    exportType: {
      placeholder: 'ประเภทรายงาน',
      label: 'ประเภทรายงาน'
    },
    language: {
      en: 'EN',
      th: 'TH'
    }
  },
  buttons: {
    export: 'ส่งออกรายงาน',
    refresh: 'รีเฟรช'
  },
  messages: {
    retention: 'รายงานเก็บไว้ 24 ชั่วโมง และลบเมื่อเบราว์เซอร์รับไฟล์ครบแล้ว',
    waitingFile:
      'กรุณาดาวน์โหลดรายงานที่รออยู่ก่อนสร้างใหม่ แม้จะเปลี่ยนประเภทรายงานหรือตัวกรอง',
    expiresAt: 'ดาวน์โหลดได้ถึง {{date}}',
    cleanupPending:
      'ระบบกำลังลบรายงานก่อนหน้า จะสร้างรายงานใหม่ได้เมื่อลบเสร็จ',
    cleanupFailed:
      'ได้รับไฟล์แล้ว แต่ยังยืนยันการลบต้นฉบับไม่ได้ กรุณารีเฟรชเพื่อตรวจสอบสถานะ',
    selectExportType: 'กรุณาเลือกประเภทรายงาน',
    submitFailed: 'ไม่สามารถเริ่มสร้างรายงานได้',
    historyLoading: 'กำลังโหลดรายการรายงาน...',
    historyEmpty: 'ยังไม่มีรายงาน กรุณากด Export เพื่อสร้างรายงาน',
    historyFailed:
      'ไม่สามารถโหลดรายการรายงานได้ กรุณากด Refresh เพื่อลองอีกครั้ง',
    downloadFailed: 'ไม่สามารถดาวน์โหลดไฟล์ได้'
  },
  exportJob: {
    success: 'รายงานพร้อมให้ดาวน์โหลดแล้ว',
    queued: {
      title: 'รายงานอยู่ในคิว',
      description: 'ระบบกำลังรอประมวลผลรายงานของคุณ'
    },
    processing: {
      title: 'กำลังสร้างรายงาน',
      description: 'คุณสามารถออกจากหน้านี้และกลับมาตรวจสอบภายหลังได้'
    },
    longRunning: {
      title: 'การสร้างรายงานใช้เวลานานกว่าปกติ',
      description: 'ระบบยังประมวลผลอยู่ คุณสามารถกลับมาตรวจสอบภายหลังได้'
    },
    failed: {
      title: 'สร้างรายงานไม่สำเร็จ',
      description: 'ระบบไม่สามารถสร้างรายงานได้ กรุณาลองอีกครั้ง'
    },
    'tracking-error': {
      title: 'ไม่สามารถติดตามสถานะรายงานได้',
      description: 'กรุณารีเฟรชประวัติเพื่อตรวจสอบว่ารายงานเสร็จแล้วหรือไม่'
    }
  },
  history: {
    table: {
      createdAt: 'วันที่',
      fileName: 'ชื่อไฟล์',
      fileUuid: 'รหัสไฟล์',
      url: 'ดาวน์โหลด'
    }
  },
  tabs: {
    'leave-report-transaction': 'รายงานการลาที่เกิดขึ้น',
    'leave-report-summary': 'รายงานรวมการลาทั้งหมด'
  },
  'leave-report-transaction': {
    'filter-form': {
      ...filterForm
    },
    table: {
      'employee-code': 'รหัสพนักงาน',
      employee: 'ข้อมูลพนักงาน',
      leaveTypeName: 'ประเภทการลา',
      duration: 'ระยะเวลาวันที่ลา',
      day: 'จำนวนวันลา',
      reason: 'เหตุผล',
      status: 'สถานะ',
      approval: 'ผู้อนุมัติ',
      create: 'วันที่สร้าง',
      approveDate: 'วันที่อนุมัติ'
    }
  },
  'leave-report-summary': {
    'filter-form': {
      ...filterForm
    },
    table: {
      'employee-code': 'รหัสพนักงาน',
      employee: 'ข้อมูลพนักงาน',
      'employee-status': 'สถานะของพนักงาน',
      'leave-type': 'ประเภทการลา',
      hire: 'วันเข้างาน',
      balance: 'คงเหลือ',
      total: 'รวมทั้งหมด',
      entitlement: 'สิทธิ์',
      used: 'ใช้ไป',
      carried: 'ยกยอด'
    }
  }
}
